<script lang="ts">
    import { closeModal } from 'svelte-modals';
    import { _ } from 'svelte-i18n';
    import ButtonMain from '../ButtonMain.svelte';
    import ButtonBack from '../ButtonBack.svelte';
    import MessageInline from '../Messages/MessageInline.svelte';
    import TemplateRow from '../TemplateRow.svelte';

    export let isOpen: boolean = false;
    export let onClick: () => void = () => {};
    export let onCancel: () => void = () => {};
    export let title: string = '';
    export let text: string = '';
</script>

{#if isOpen}
    <div role="dialog" class="modal">
        <div class="contents">
            <h2 style="text-align: center;">{$_(title)}</h2>

            <TemplateRow>
                <MessageInline text={$_(text)} />
            </TemplateRow>

            <div class="actions">
                <ButtonBack
                    text={$_('Cancel')}
                    showIcon={false}
                    on:click={() => {
                        onCancel();
                        closeModal();
                    }}
                />
                <ButtonMain
                    text={$_('OK')}
                    disabled={false}
                    showIcon={false}
                    on:click={() => {
                        onClick();
                        closeModal();
                    }}
                />
            </div>
        </div>
    </div>
{/if}

<style>
    .modal {
        position: fixed;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1002;

        /* allow click-through to backdrop */
        pointer-events: none;
    }

    .contents {
        width: 390px;
        border-radius: 6px;
        background: white;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        pointer-events: auto;
        font-size: 14px;
        padding: 30px;
    }

    .actions {
        margin-top: 32px;
        display: flex;
        justify-content: center;
        column-gap: 10px;
    }
</style>
